import CategoryApi from 'api/category';
import { NavLink, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

function useQueryParams() {
  return new URLSearchParams(useLocation().search);
}

const CategoryMenu = function () {
  const { t } = useTranslation();
  const queryParams = useQueryParams();

  const fetch = () => CategoryApi.fetch();
  const { isLoading, data = [] } = useQuery('categories', fetch);

  if (isLoading) {
    return 'loading...';
  }

  const links = [];

  for (const category of data) {
    links.push(
      <li key={category.id}>
        <NavLink to={`?category=${category.id}`} isActive={() => category.id === queryParams.get('category')}>
          {category.name}
        </NavLink>
      </li>
    );
  }

  return (
    <div className="category-menu">
      <ul>
        <li>
          <NavLink to="/marketplace" isActive={() => !queryParams.get('category')}>
            {t('keys.all')}
          </NavLink>
        </li>

        {links}
      </ul>
    </div>
  );
};

export default CategoryMenu;
